import React, { Component } from 'react';
import {Checkbox} from  "@amzn/awsui-components-react";
import PropTypes from "prop-types";
import * as roleNames from '../../../constants/roleNames.const';
export default class AWScheckbox extends Component {
    onChangeFunc = (value) => {
        this.props.onChangeFunc(value);
    }

    checkForDisable = (canEditPPR) => {
        if (canEditPPR === false) {
            return true 
        } else {
            return false
        }
    }

    render() {
        const { label, onChangeFunc, checked, userRole, canEditPPR } = this.props;
        return (
            <div className="checkbox-div">
                <Checkbox 
                    id={label}
                    label={label}
                    checked={checked}
                    disabled={this.checkForDisable(canEditPPR)}
                    onChange={(e) => onChangeFunc(e.detail.checked)}
                ></Checkbox>
            </div>
        );
    }
}
AWScheckbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChangeFunc: PropTypes.func
};


